export default {
	Code: {
		User: {
			REQUIRED_CAPTCHA: '30001',
			WITHDRAWAL_USER: '30003',
			WITHDRAWAL_DONE_USER: '30014',
			BLACK_LIST_USER: '30004',
			INVALID_SNS_TOKEN: '30005',
			DUPLICATED_SNS_USER: '30007',
			NOT_FOUND_USER: '30008',
		},
		EwImported: {
			INVALID_RESERVATION_DATETIME: '50007',
			INVALID_TEMPORARY_RESERVATION_DATETIME: '50021',
			ALREADY_WARRANTY_CAR: '50032',
		},
	},
	LogMessage: {
		STORAGE_SECURE: 'Session Storage is disabled',
	},
	Message: {
		LOG_IN_FAIL_WITH_CAPTCHA: '아이디 또는 비밀번호를 잘못 입력하셨습니다.\n하단에 버튼을 클릭해 인증 진행 후 로그인을 시도해주세요.',
		LOG_IN_FAIL: '아이디 또는 비밀번호를 잘못 입력하셨습니다.\n5회 이상 틀릴 경우 로그인이 제한됩니다.',
		WITHDRAWAL_DONE_USER:
			'장기 미이용자로서 관련 법규에 의거 탈퇴 처리되었으며, 고객님의 개인 정보는 모두 삭제 처리되었음을 알려 드립니다.\n신규 아이디로 재가입하여 이용해 주시기 바랍니다.',
		EW_CAR_CHECK_FAILURE: '차량정보를 가져오는 중에 문제가 발생했습니다.',
		EW_INVALID_RESERVATION_DATETIME: '죄송합니다. 유효하지 않은 예약시간입니다.',
		EW_ALREADY_RESERVED_DATETIME: '죄송합니다. 이미 예약된 시간입니다.',
		EW_ALREADY_CAR: '이미 보증에 가입된 차량입니다.',
	},
};
